import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("path", {
    d: "M14 14.5H3.06667C2.6933 14.5 2.50661 14.5 2.36401 14.4273C2.23856 14.3634 2.13658 14.2614 2.07266 14.136C2 13.9934 2 13.8067 2 13.4333V2.5M13.3333 5.83333L10.7208 8.62177C10.6217 8.72745 10.5722 8.78029 10.5125 8.8076C10.4598 8.8317 10.4017 8.84164 10.344 8.83644C10.2786 8.83055 10.2143 8.79718 10.0858 8.73045L7.91421 7.60288C7.78569 7.53615 7.72143 7.50278 7.65602 7.49689C7.59829 7.49169 7.54021 7.50163 7.48749 7.52574C7.42777 7.55305 7.37826 7.60589 7.27925 7.71156L4.66667 10.5",
    stroke: $props.color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}